module.exports = __webpack_public_path__ + "img/distance-driven.5daa81b6.png";